import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { IonicModule } from '@ionic/angular'
import { ComponentsModule } from 'src/app/components/components.module'

import { TermsPageRoutingModule } from './terms-routing.module'
import { TermsPage } from './terms.page'

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TermsPageRoutingModule, ComponentsModule],
  declarations: [TermsPage]
})
export class TermsPageModule {}
